/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowLoopRight = createReactComponent("arrow-loop-right", "IconArrowLoopRight", [
  ["path", { d: "M12 21v-13a4 4 0 1 0 -4 4h13", key: "svg-0" }],
  ["path", { d: "M17 16l4 -4l-4 -4", key: "svg-1" }]
]);

export { IconArrowLoopRight as default };
//# sourceMappingURL=IconArrowLoopRight.js.map
